import React, { useState, useEffect, useRef, useCallback } from 'react';
import { fetchCollegeAutocomplete } from './realTalkApi';

const COURSE_OPTIONS = [
  'B.Tech', 'B.E.', 'BBA', 'BCA', 'B.Com', 'B.Sc', 'BA', 'B.Arch',
  'MBBS', 'BDS', 'B.Pharm', 'LLB', 'B.Des', 'BHM', 'B.Ed',
  'M.Tech', 'MBA', 'MCA', 'M.Com', 'M.Sc', 'MA', 'M.Arch',
  'MD', 'MS', 'M.Pharm', 'LLM', 'M.Des', 'PhD', 'Other',
];

export default function FilterBar({ filters, onFilterChange }) {
  const [collegeInput, setCollegeInput] = useState(filters.college || '');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const debounceRef = useRef(null);
  const wrapperRef = useRef(null);

  const handleCollegeSearch = useCallback((val) => {
    setCollegeInput(val);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (val.length < 2) { setSuggestions([]); setShowSuggestions(false); if (!val) onFilterChange({ ...filters, college: '' }); return; }
    debounceRef.current = setTimeout(async () => {
      const results = await fetchCollegeAutocomplete(val);
      setSuggestions(results);
      setShowSuggestions(results.length > 0);
    }, 300);
  }, [filters, onFilterChange]);

  useEffect(() => {
    const handleClick = (e) => { if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setShowSuggestions(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const selectCollege = (name) => { setCollegeInput(name); setShowSuggestions(false); onFilterChange({ ...filters, college: name }); };
  const handleCollegeSubmit = (e) => { if (e.key === 'Enter') { e.preventDefault(); onFilterChange({ ...filters, college: collegeInput }); setShowSuggestions(false); } };
  const clearFilters = () => { setCollegeInput(''); onFilterChange({ college: '', course: '', minRating: '' }); };
  const hasActiveFilters = filters.college || filters.course || filters.minRating;

  return (
    <div className="rt-filter-bar" data-testid="rt-filter-bar">
      <div className="rt-filter-row">
        <div className="rt-filter-field" ref={wrapperRef}>
          <input type="text" value={collegeInput} onChange={(e) => handleCollegeSearch(e.target.value)} onKeyDown={handleCollegeSubmit} placeholder="🔍 Search college..." className="rt-filter-input" data-testid="rt-filter-college" />
          {showSuggestions && (
            <ul className="rt-autocomplete-list rt-filter-suggestions">
              {suggestions.map((name, idx) => (<li key={idx} onClick={() => selectCollege(name)} className="rt-autocomplete-item">{name}</li>))}
            </ul>
          )}
        </div>
        <select value={filters.course} onChange={(e) => onFilterChange({ ...filters, course: e.target.value })} className="rt-filter-select" data-testid="rt-filter-course">
          <option value="">All Courses</option>
          {COURSE_OPTIONS.map((c) => (<option key={c} value={c}>{c}</option>))}
        </select>
        <select value={filters.minRating} onChange={(e) => onFilterChange({ ...filters, minRating: e.target.value })} className="rt-filter-select" data-testid="rt-filter-rating">
          <option value="">All Ratings</option>
          <option value="4">4+ Stars</option>
          <option value="3">3+ Stars</option>
          <option value="2">2+ Stars</option>
          <option value="1">1+ Stars</option>
        </select>
        {hasActiveFilters && (<button onClick={clearFilters} className="rt-filter-clear" data-testid="rt-filter-clear">✕ Clear</button>)}
      </div>
    </div>
  );
}
